import axiosInstance from "../../axios/axios";

export const SendOtpApi = async (credential) =>
  await axiosInstance.post(`/vozo/user/otp/send`, credential);
